import React from "react"
import video from "../images/waves.mp4"








function Main () {

    return (
        <div>
            <video src={video} autoPlay loop muted/>
           

        </div>
    )
}

export default Main